import React from "react";
import { cn } from "../../lib/utils";

export const Button = React.forwardRef(
  ({ className, variant = "primary", size = "md", asChild = false, ...props }, ref) => {
    const base =
      "inline-flex items-center justify-center gap-2 rounded-sm font-medium transition-crisp focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-900 disabled:opacity-50 disabled:cursor-not-allowed";
    const variants = {
      primary:
        "bg-ink-900 text-white hover:bg-ink-800 border border-ink-900",
      brand:
        "bg-brand-400 text-ink-900 hover:bg-brand-500 hover:text-white border border-brand-400 hover:border-brand-500",
      secondary:
        "bg-white text-ink-900 hover:bg-ink-100 border border-ink-300",
      ghost:
        "bg-transparent text-ink-900 hover:bg-ink-100 border border-transparent",
      danger:
        "bg-white text-status-abgelehnt-text hover:bg-status-abgelehnt-bg border border-status-abgelehnt-border",
      success:
        "bg-white text-status-aktiv-text hover:bg-status-aktiv-bg border border-status-aktiv-border",
    };
    const sizes = {
      sm: "px-3 py-1.5 text-sm",
      md: "px-4 py-2 text-sm",
      lg: "px-6 py-3 text-base",
    };
    return (
      <button
        ref={ref}
        className={cn(base, variants[variant], sizes[size], className)}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";
